import cx from 'classnames'
import React, { useEffect } from 'react'

import { isHouseRelatedType } from '@js/common/utils'

import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import ActionCardTemplate from '@f/elements/ActionCardTemplate'
import Icon from '@f/elements/Icon'

const UserProperty = props => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'property' })
  }, [])

  const isConversionFunnel = Boolean(props.funnelVariant)

  const handleSelection = value => {
    let detail = {}

    detail['property'] = value

    _wt({
      category: 'form',
      action: 'submit',
      location: 'modal-property',
      values: [
        {
          type: 'property',
          value: value
        }
      ],
      ...props.data.trackingInfo
    })

    props.actions.handleUserDataChange({
      detail,
      forcePostRequest: isHouseRelatedType(props.requestType)
    })

    props.actions.move({})
  }

  const options = [
    {
      value: 'yes',
      CardIcon: () => (
        <Icon
          icon='pin-check-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'Ja'
    },
    {
      value: 'reserved',
      CardIcon: () => (
        <Icon
          icon='reserved-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'Reserviert'
    },
    {
      value: 'expected',
      CardIcon: () => (
        <Icon
          icon='clock-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'In Aussicht'
    },
    {
      value: 'no',
      CardIcon: () => (
        <Icon
          icon='remove-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'Nein'
    }
  ]

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}
      data-wtloc='modal-property'>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Haben Sie bereits ein Grundstück?
          </div>
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-overflow ]'>
            <div className='RequestWizard-options-wrapper'>
              {options.map(option => (
                <QuestionRadioButton
                  key={option.value}
                  wtData={{
                    location: 'modal-property',
                    flow_information: props.data.trackingInfo.flow_information
                  }}
                  onClick={() => handleSelection(option.value)}>
                  <ActionCardTemplate
                    sizeActionCard={isConversionFunnel ? 'large' : undefined}
                    {...option}
                  />
                </QuestionRadioButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserProperty
